interface ControlProps {}

const Control: React.FC<React.PropsWithChildren<ControlProps>> = ({ children }) => {
  return <>{children}</>;
};

export default Control;
